<template>
  <LayoutAutenticado>
    
    <div class="equipments-dashboard fade-in-up">
      <!-- Header Module -->
      <header class="page-header">
        <div>
           <h1 class="page-title">Inventário de Equipamentos</h1>
           <p class="page-subtitle">Gerencie aparelhos para Recebíveis e Pagamentos do sistema.</p>
        </div>
        <div class="header-actions">
           <RoleGate minLevel="supervisor" :showWhenDenied="true">
             <AddButton label="Novo Perfil" @click="isModalPerfil = true" />
           </RoleGate>
        </div>
      </header>

      <div class="dashboard-body">
        
        <!-- Bloco: Recebíveis -->
        <div v-if="listProfileValuesReceiver.length > 0" class="profile-section">
          <h3 class="section-heading"><i class="bi bi-box-arrow-in-down-right text-success"></i> Dispositivos de Serviço (Recebíveis)</h3>
          
          <div v-for="(item, index) in listProfileValuesReceiver" :key="'rec-'+index" class="accordion-item">
            
            <button class="accordion-header" type="button" @click="toggleCollapseRecebiveis(index)" :class="{ 'is-open': openCollapsesRecebiveis.includes(index) }">
               <div class="accordion-title">
                 <i class="bi bi-tag-fill icon-marker"></i>
                 <span>{{ item.name }}</span>
               </div>
               <i class="bi bi-chevron-down chevron"></i>
            </button>

            <div class="accordion-content" :class="{ 'collapsed': !openCollapsesRecebiveis.includes(index) }">
              <div class="accordion-body-inner">
                
                <RoleGate minLevel="supervisor" :showWhenDenied="true">
                   <div class="actions-row">
                     <AddButton label="Adicionar Equipamento" @click="adicionarEquipamento(item)" />
                   </div>
                </RoleGate>

                <div class="equipment-grid">
                  <div class="equipment-card" v-for="(equips) in item.equipments" :key="equips.equipId">
                    
                    <div class="card-image-box">
                      <!-- Renderizando a URL externa (Backend Image Storage) vazia ou válida -->
                      <img class="img-fluid" v-if="equips.image" :src="equips.image" alt="Equipamento" />
                      <div v-else class="image-placeholder"><i class="bi bi-image"></i></div>
                    </div>

                    <div class="card-details">
                      <div class="form-group">
                        <label>ID Hardware</label>
                        <div class="input-wrapper locked">
                          <i class="bi bi-upc-scan icon"></i>
                          <input type="text" class="form-control" v-model="equips.equipId" disabled>
                        </div>
                      </div>

                      <RoleGate minLevel="supervisor" :showWhenDenied="true">
                        <div class="form-group">
                          <label>Nome do Equipamento</label>
                          <div class="input-wrapper">
                            <i class="bi bi-cpu-fill icon text-primary"></i>
                            <input type="text" class="form-control" v-model="equips.name" placeholder="Ex: Roteador Cisco">
                          </div>
                        </div>

                        <div class="form-group">
                          <label>Valor / Custo Relativo</label>
                          <div class="input-wrapper">
                            <i class="bi bi-currency-dollar icon text-success"></i>
                            <input type="text" class="form-control" v-model="equips.value" placeholder="0.00">
                          </div>
                        </div>

                        <div class="form-group setup-status">
                          <label>Status</label>
                          <label class="modern-switch">
                            <input type="checkbox" v-model="equips.status" :checked="Boolean(equips.status)">
                            <span class="slider"></span>
                          </label>
                        </div>
                      </RoleGate>
                    </div>

                  </div>
                </div>

                <div class="save-bar mt-4" v-if="item.equipments && item.equipments.length > 0">
                   <RoleGate minLevel="supervisor" :showWhenDenied="true">
                      <BotaoSalvar @click="editPerfil(item)" />
                   </RoleGate>
                </div>

              </div>
            </div>
          </div>
        </div>


        <!-- Bloco: Pagamento -->
        <div v-if="listProfileValuesPagment.length > 0" class="profile-section mt-5">
          <h3 class="section-heading"><i class="bi bi-box-arrow-up-right text-warning"></i> Dispositivos Financeiros (Pagamento)</h3>
          
          <div v-for="(item, index) in listProfileValuesPagment" :key="'pag-'+index" class="accordion-item">
            
            <button class="accordion-header" type="button" @click="toggleCollapse(index)" :class="{ 'is-open': openCollapses.includes(index) }">
               <div class="accordion-title">
                 <i class="bi bi-wallet2 icon-marker text-warning"></i>
                 <span>{{ item.name }}</span>
               </div>
               <i class="bi bi-chevron-down chevron"></i>
            </button>

            <div class="accordion-content" :class="{ 'collapsed': !openCollapses.includes(index) }">
              <div class="accordion-body-inner">
                
                <RoleGate minLevel="supervisor" :showWhenDenied="true">
                   <div class="actions-row spread">
                     <AddButton label="Adicionar Módulo" @click="adicionarEquipamento(item)" />
                     <RemoveButton label="Remover Módulo" v-if="item.equipments && item.equipments.length > 0" @click="removerEquipamento(item)" />
                   </div>
                </RoleGate>

                <div class="equipment-grid">
                  <div class="equipment-card" v-for="(equips) in item.equipments" :key="equips.equipId">
                    
                    <div class="card-image-box">
                      <!-- URL Imagem Storage Frontend Rendering -->
                      <img class="img-fluid" v-if="equips.image" :src="equips.image" alt="Módulo" />
                      <div v-else class="image-placeholder"><i class="bi bi-image"></i></div>
                    </div>

                    <div class="card-details">
                      <div class="form-group">
                        <label>ID Hardware</label>
                        <div class="input-wrapper locked">
                          <i class="bi bi-upc-scan icon"></i>
                          <input type="text" class="form-control" v-model="equips.equipId" disabled>
                        </div>
                      </div>

                      <RoleGate minLevel="supervisor" :showWhenDenied="true">
                        <div class="form-group">
                          <label>Nome do Módulo</label>
                          <div class="input-wrapper">
                            <i class="bi bi-terminal-fill icon text-primary"></i>
                            <input type="text" class="form-control" v-model="equips.name" placeholder="Leitor Pagbank...">
                          </div>
                        </div>

                        <div class="form-group">
                          <label>Custo Tabela</label>
                          <div class="input-wrapper">
                            <i class="bi bi-cash-coin icon text-success"></i>
                            <input type="text" class="form-control" v-model="equips.value" placeholder="0.00">
                          </div>
                        </div>

                        <div class="form-group setup-status">
                          <label>Status Operacional</label>
                          <label class="modern-switch">
                            <input type="checkbox" v-model="equips.status" :checked="Boolean(equips.status)">
                            <span class="slider"></span>
                          </label>
                        </div>
                      </RoleGate>

                    </div>
                  </div>
                </div>

                <div class="save-bar mt-4" v-if="item.equipments && item.equipments.length > 0">
                   <RoleGate minLevel="supervisor" :showWhenDenied="true">
                      <BotaoSalvar @click="editPerfil(item)" />
                   </RoleGate>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Modals Restritos Integrados -->
    <ModalEquipamentos :isVisible="isModalVisible" :listaDeEquipamentos="listaDeEquipamentos" @close="closeModal" />

    <!-- Novo Perfil Modal V2 -->
    <Modal :isVisible="isModalPerfil" @close="isModalPerfil = false">
      <div class="modal-header-v2">
         <h3>Novo Grupo de Acesso</h3>
         <button class="close-btn" @click="isModalPerfil = false"><i class="bi bi-x-lg"></i></button>
      </div>

      <div class="modal-body-v2">
        <div class="form-group full-width">
          <label>Nome do Perfil de Pagamento / Serviço</label>
          <div class="input-wrapper">
             <i class="bi bi-tags-fill icon text-primary"></i>
             <input type="text" class="form-control" v-model="namePerfil" placeholder="Ex: Antenas Plus" required />
          </div>
        </div>
      </div>

      <div class="modal-footer-v2 mt-4">
         <button class="btn-cancel" @click="isModalPerfil = false">Cancelar</button>
         <BotaoSalvar @click="saveNewPerfil" />
      </div>
    </Modal>

    <!-- Sistema de Alertas Toast -->
    <div class="toast-container position-fixed bottom-0 end-0 p-3" style="z-index: 1055;">
      <div id="liveToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="toast-header">
          <i class="bi bi-info-circle-fill text-primary me-2"></i>
          <strong class="me-auto">Alerta do Sistema</strong>
          <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        <div class="toast-body" id="toastBody">
          Aqui aparecerá a mensagem.
        </div>
      </div>
    </div>

  </LayoutAutenticado>
</template>

<script setup>
import BotaoSalvar from '@/components/ui/BotaoSalvar.vue';
import ModalEquipamentos from '../components/ModalEquipamentos.vue';
import LayoutAutenticado from '@/components/layouts/LayoutAutenticado.vue';
import Modal from '@/components/Modal.vue';
import { showToast } from '@/eventBus.js';
import AddButton from '../components/ui/BtnAdicionar.vue';
import RemoveButton from '../components/ui/BtnRemover.vue';

import axios from '@/axios.js';
import { ref, onMounted } from 'vue';
import RoleGate from '../components/RoleGate.vue';

const listProfileValuesPagment = ref([]);
const listProfileValuesReceiver = ref([]);
const isModalVisible = ref(false);
const isModalPerfil = ref(false);
const openCollapses = ref([]);
const openCollapsesRecebiveis = ref([]);
const listaDeEquipamentos = ref({});
const namePerfil = ref('');

onMounted(async () => {
  getProfileValues();
});

function getProfileValues() {
  const companyId = localStorage.getItem("idCompany");

  axios.get(`/api/profile-value/${companyId}`)
    .then(response => {
      listProfileValuesPagment.value = response.data.pagment || [];
      listProfileValuesReceiver.value = response.data.receiver || [];
    }).catch(error => {
      showToast(error.message || "Erro ao buscar estruturas no servidor.");
    });
}

function adicionarEquipamento(perfilEdit) {
  isModalVisible.value = true;
  listaDeEquipamentos.value = perfilEdit;
};

function removerEquipamento(perfilEdit) {
  const companyId = localStorage.getItem("idCompany");

  axios.delete(`/api/profile-value/${companyId}`, { headers: { 'Content-Type': 'application/json' }, data: perfilEdit })
    .then(response => {
      showToast(response.data.message || 'Módulo removido com êxito.');

      const updatedProfile = response.data.profile;
      const index = listProfileValuesPagment.value.findIndex(p => p.id === updatedProfile.id);
      if (index !== -1) {
        listProfileValuesPagment.value[index] = updatedProfile;
      }
    }).catch(error => {
      showToast(error?.response?.data || "Falha na remoção do equipamento.");
    });
};

function closeModal() {
  isModalVisible.value = false;
};

function toggleCollapse(index) {
  const position = openCollapses.value.indexOf(index);
  if (position !== -1) {
    openCollapses.value.splice(position, 1);
  } else {
    openCollapses.value.push(index); 
  }
};

function toggleCollapseRecebiveis(index) {
  const position = openCollapsesRecebiveis.value.indexOf(index);
  if (position !== -1) {
    openCollapsesRecebiveis.value.splice(position, 1);
  } else {
    openCollapsesRecebiveis.value.push(index);
  }
};

function saveNewPerfil() {
  const companyId = localStorage.getItem("idCompany");

  axios.post(`/api/profile-value/saveNewProfile/${companyId}`, namePerfil.value, { headers: { 'Content-Type': 'text/plain' } })
    .then(response => {
      isModalPerfil.value = false;
      showToast(response.data.message || 'Grupo salvo com sucesso.');
      getProfileValues();
      namePerfil.value = '';
    })
    .catch(error => {
      const mensagem = error?.response?.data || "Discrepância nos parâmetros da API.";
      showToast(mensagem);
    });
};

function editPerfil(perfil) {
  const companyId = localStorage.getItem("idCompany");

  axios.put(`/api/profile-value/${companyId}`, perfil)
    .then(response => {
      showToast(response.data.message || 'Configurações de módulo atualizadas.');

      const updatedProfile = response.data.profile;
      const index = listProfileValuesPagment.value.findIndex(p => p.id === updatedProfile.id);
      if (index !== -1) {
        listProfileValuesPagment.value[index] = updatedProfile;
      }
    })
    .catch(error => {
      showToast(error?.message || "Exceção ao sincronizar equipamentos.");
    });
};
</script>

<style scoped>
/* Page Layout Params */
.equipments-dashboard {
  width: 100%;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 2.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.page-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: #1E293B;
  margin-bottom: 0.25rem;
}

.page-subtitle {
  font-size: 0.95rem;
  color: #64748B;
  margin: 0;
}

.dashboard-body {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-bottom: 4rem;
}

.section-heading {
  font-size: 1.15rem;
  font-weight: 700;
  color: #334155;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Base SaaS Accordion */
.accordion-item {
  background: #FFFFFF;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  margin-bottom: 1rem;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
  transition: box-shadow 0.2s ease;
}

.accordion-item:hover {
  box-shadow: 0 6px 12px rgba(0,0,0,0.04);
}

.accordion-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  background: #FFFFFF;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
}

.accordion-header.is-open {
  background: #F8FAFC;
  border-bottom: 1px solid #E2E8F0;
}

.accordion-header:hover {
  background: #F8FAFC;
}

.accordion-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 700;
  color: #0F172A;
  font-size: 1.05rem;
}

.icon-marker {
  color: #DF523A;
  font-size: 1.2rem;
}

.chevron {
  color: #94A3B8;
  font-size: 1.1rem;
  transition: transform 0.3s ease;
}

.accordion-header.is-open .chevron {
  transform: rotate(180deg);
}

.accordion-content {
  display: grid;
  grid-template-rows: 1fr;
  transition: grid-template-rows 0.3s ease, margin 0.3s ease;
}
.accordion-content.collapsed {
  grid-template-rows: 0fr;
}
.accordion-body-inner {
  overflow: hidden;
  padding: 0 1.5rem;   /* We use padding 0 1.5 when collapsed physically but handled logically */
}

/* Actions logic */
.accordion-content:not(.collapsed) .accordion-body-inner {
  padding: 1.5rem;
}
.actions-row {
  margin-bottom: 1.5rem;
}
.actions-row.spread {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

/* Hardware Equipment Grid */
.equipment-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
}

.equipment-card {
  background: #FFFFFF;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.equipment-card:hover {
  border-color: #CBD5E1;
  transform: translateY(-2px);
}

.card-image-box {
  width: 100%;
  height: 180px;
  background: #F8FAFC;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #E2E8F0;
  padding: 1rem;
}

.img-fluid {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.image-placeholder {
  color: #CBD5E1;
  font-size: 3rem;
}

.card-details {
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Form structure */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.form-group label {
  font-weight: 600;
  color: #475569;
  font-size: 0.85rem;
}

.form-group.setup-status {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
}

.input-wrapper {
  display: flex;
  align-items: center;
  background-color: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  padding: 0.4rem 0.8rem;
  transition: all 0.2s ease;
}

.input-wrapper:focus-within {
  border-color: #DF523A;
  background-color: #FFF;
  box-shadow: 0 0 0 3px rgba(223, 82, 58, 0.1);
}

.input-wrapper.locked {
  background-color: #F1F5F9;
  cursor: not-allowed;
}

.input-wrapper .icon {
  font-size: 1.1rem;
  color: #94A3B8;
  margin-right: 0.5rem;
}

.form-control {
  flex: 1;
  background: transparent;
  border: none;
  font-family: inherit;
  font-size: 0.95rem;
  color: #1E293B;
  outline: none;
  min-width: 0; 
}
.form-control::placeholder { color: #CBD5E1; }

.save-bar {
  display: flex;
  justify-content: flex-end;
  border-top: 1px dashed #E2E8F0;
  padding-top: 1.5rem;
}

/* Global utility */
.text-primary { color: #3B82F6 !important; }
.text-success { color: #10B981 !important; }
.text-warning { color: #F59E0B !important; }

/* Modern Switch */
.modern-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
}

.modern-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #CBD5E1;
  transition: .3s;
  border-radius: 22px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .3s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #10B981; 
}
input:checked + .slider:before {
  transform: translateX(18px);
}

/* Modals Override Settings */
.modal-header-v2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 1px solid #E2E8F0;
  margin-bottom: 1.5rem;
}

.modal-header-v2 h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 800;
  color: #0F172A;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 1.25rem;
  color: #94A3B8;
  cursor: pointer;
}
.close-btn:hover { color: #EF4444; }

.modal-footer-v2 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  border-top: 1px solid #E2E8F0;
  padding-top: 1.5rem;
}

.btn-cancel {
  background: transparent;
  border: none;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  padding: 0.5rem 1rem;
}
.btn-cancel:hover { color: #0F172A; }

/* Animations */
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}
.fade-in-up {
  animation: fadeInUp 0.5s ease forwards;
}

@media (max-width: 767.98px) {
  .actions-row.spread {
    flex-direction: column;
  }
}
</style>
